import React from 'react';
import { CcIcon } from '@utp/components-react';
import useField, { IFieldProps } from '@/core/hooks/useField';
import { WrapperInput } from './styled';

const Input = (props: IFieldProps) => {
  const { counter, errors, field, maxLength, showCounter } = useField(props);

  return (
    <WrapperInput>
      <input type="text" {...field} data-testid="cmp-reusable-input-text" />
      {(errors.length > 0 || showCounter) && (
        <div>
          <div>
            {errors.length > 0 && (
              <>
                <CcIcon size={16} name="alert-triangle" />
                <span>{errors[0]}</span>
              </>
            )}
          </div>
          <div>
            {showCounter && (
              <>
                <span>{counter}</span>
                {maxLength && maxLength > 0 ? <span> / {maxLength}</span> : ''}
              </>
            )}
          </div>
        </div>
      )}
    </WrapperInput>
  );
};

export default Input;
